// removed by extract-text-webpack-plugin
module.exports = {"block":"_2rlA2h_sfKF24xTn4bfsYs","zebra":"_2kYQZ6XlE_XLmhqSFTQAnq","zebraBlue":"_3if_UXiGiJD-jsp650VBmQ","list":"_2s6CLEaiqcAijGS6Fp3jan","yellow":"_7o5wNk0R1ui-F0NDYaAy1","darkgray":"_34ulKr3DQjtypAWffXhVjO","wrapper":"XA6RlfLpJjn28lObZL6q3","heading":"_2aSK9734ckuh9IEeawFvTP"};


//////////////////
// WEBPACK FOOTER
// ./src/components/InfographicListBlock/InfographicListBlock.module.scss
// module id = 779
// module chunks = 0